(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1466],{

/***/ 70773:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[partnership]",
      function () {
        return __webpack_require__(43308);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var LightroomImportIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "38",
        height: "28",
        viewBox: "0 0 38 28",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M35.9999 14C35.9999 20.6274 30.6274 26 23.9999 26C18.8623 26 14.4788 22.7713 12.7676 18.2323L11.2372 19.7627C13.4339 24.6202 18.3222 28 23.9999 28C31.7319 28 37.9999 21.732 37.9999 14C37.9999 6.26801 31.7319 0 23.9999 0C18.0516 0 12.9697 3.70968 10.9417 8.9417L12.5141 10.5141C14.0075 5.58676 18.5849 2 23.9999 2C30.6274 2 35.9999 7.37258 35.9999 14Z",
                fill: "#1C1C1C"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.67655 21.7379L13.0405 15.3739C13.431 14.9834 13.431 14.3502 13.0405 13.9597L6.67656 7.59573C6.28604 7.20521 5.65287 7.20521 5.26235 7.59573C4.87182 7.98626 4.87182 8.61942 5.26235 9.00995L9.9192 13.6668L1 13.6668C0.447716 13.6668 0 14.1145 0 14.6668C0 15.2191 0.447715 15.6668 1 15.6668L9.9192 15.6668L5.26234 20.3237C4.87182 20.7142 4.87182 21.3473 5.26234 21.7379C5.65287 22.1284 6.28603 22.1284 6.67655 21.7379Z",
                fill: "#1C1C1C"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18 11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11V17C16 17.5523 16.4477 18 17 18H20C20.5523 18 21 17.5523 21 17C21 16.4477 20.5523 16 20 16H18V11Z",
                fill: "#1C1C1C"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M22.5 12C21.9477 12 21.5 12.4477 21.5 13V17C21.5 17.5523 21.9477 18 22.5 18C23.0523 18 23.5 17.5523 23.5 17V14H24.5C25.0523 14 25.5 13.5523 25.5 13C25.5 12.4477 25.0523 12 24.5 12H22.5Z",
                fill: "#1C1C1C"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M30 12C28.8954 12 28 12.8954 28 14C28 15.1046 28.8954 16 30 16C30.5129 16 30.9786 15.8083 31.3331 15.491C31.7446 15.1226 32.3768 15.1577 32.7451 15.5692C33.1135 15.9807 33.0784 16.6129 32.6669 16.9812C31.9599 17.614 31.0238 18 30 18C27.7909 18 26 16.2091 26 14C26 11.7909 27.7909 10 30 10C31.0238 10 31.9599 10.386 32.6669 11.0188C33.0784 11.3871 33.1135 12.0193 32.7451 12.4308C32.3768 12.8423 31.7446 12.8774 31.3331 12.509C30.9786 12.1917 30.5129 12 30 12Z",
                fill: "#1C1C1C"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LightroomImportIcon);


/***/ }),

/***/ 43308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _partnership_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/useQuerySubscription/index.js + 2 modules
var useQuerySubscription = __webpack_require__(63430);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/Seo/renderMetaTags.js
var renderMetaTags = __webpack_require__(12569);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/Image/index.js + 3 modules
var Image = __webpack_require__(44087);
// EXTERNAL MODULE: ./src/components/index.ts + 103 modules
var components = __webpack_require__(80338);
// EXTERNAL MODULE: ./src/components/PlanComparison/PlanComparison.tsx + 1 modules
var PlanComparison = __webpack_require__(35888);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@narrative-software/narrative-web-ui/dist/index.js
var dist = __webpack_require__(67199);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Markdown/Md.tsx



/**
 * A really really basic markdown parser. Accepts replacers, so
 * the caller can style the markdown as they see fit.
 */ var Md = function(param) {
    var children = param.children, _replacers = param.replacers, replacers = _replacers === void 0 ? {} : _replacers;
    return /*#__PURE__*/ react.createElement.apply(void 0, [
        react.Fragment,
        {}
    ].concat((0,_to_consumable_array/* default */.Z)(convertMarkdown(children, replacers).flat())));
};
function convertMarkdown(markdown, replacers) {
    var boldParts = markdown.split("**");
    if (boldParts.length > 1) {
        return boldParts.map(function(chunk, index) {
            var convertedChunk = convertMarkdown(chunk, replacers);
            if (index % 2 === 0) {
                return convertedChunk;
            } else {
                return replacers.strong ? replacers.strong(convertedChunk) : /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: convertedChunk
                });
            }
        });
    }
    var emParts = markdown.split("*");
    if (emParts.length > 1) {
        return emParts.map(function(chunk, index) {
            var convertedChunk = convertMarkdown(chunk, replacers);
            if (index % 2 === 0) {
                return convertedChunk;
            } else {
                return replacers.em ? replacers.em(convertedChunk) : /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                    children: convertedChunk
                });
            }
        });
    }
    return [
        markdown
    ];
}


;// CONCATENATED MODULE: ./src/components/WorkflowSteps/WorkflowSteps.tsx






var workflowStepsFields = "\ntitle\nsteps {\n  ... on WorkflowStepRecord {\n    title\n    description\n    maxDescriptionWidth\n    image {\n      responsiveImage {\n        ...responsiveImageFragment\n      }\n    }\n  }\n  ... on WorkflowDividerRecord {\n    kind\n  }\n}\n";
var WorkflowSteps = function(param) {
    var title = param.title, steps = param.steps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
        className: "bg-white overflow-x-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.HorizontalRule, {
                    bottomMargin: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-h2 font-semibold leading-compact text-center mb-14 lg:mb-16",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col items-center lg:flex-row lg:items-start lg:justify-between",
                    children: steps === null || steps === void 0 ? void 0 : steps.map(function(step, index) {
                        return "kind" in step ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden mt-19 lg:flex",
                            children: step.kind === "Right Arrow" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/arrow-right.svg",
                                alt: "",
                                width: "47",
                                height: "16",
                                unoptimized: true
                            }) || /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/arrow-left-right.svg",
                                alt: "",
                                width: "47",
                                height: "16",
                                unoptimized: true
                            })
                        }, index) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex flex-col flex-1 items-center justify-center text-center mx-[-57px] my-3 lg:my-[-32px] first:-mt-0 first:lg:my-[-32px] max-w-[400px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    data: step.image.responsiveImage
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-3 text-h3 font-semibold lg:mt-4",
                                    children: step.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-3 text-balance",
                                    style: {
                                        maxWidth: step.maxDescriptionWidth
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Md, {
                                        replacers: {
                                            strong: function(chunk) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-semibold",
                                                    children: chunk
                                                });
                                            }
                                        },
                                        children: step.description
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};


// EXTERNAL MODULE: ./src/modules/index.ts + 36 modules
var modules = __webpack_require__(18838);
// EXTERNAL MODULE: ./src/modules/site-banner.tsx
var site_banner = __webpack_require__(6985);
// EXTERNAL MODULE: ./src/components/icons/LightroomImportIcon.tsx
var LightroomImportIcon = __webpack_require__(98258);
;// CONCATENATED MODULE: ./src/components/ProductFeatures/ProductFeatures.tsx




var productFeaturesSectionFields = "\n  title\n  productFeatures {\n    icon\n    title\n    description\n    videoOrImage {\n      responsiveImage {\n        ...responsiveImageFragment\n      }\n      video {\n        mp4Url\n        thumbnailUrl\n        width\n        height\n      }\n    }\n    afterMarginClasses\n  }\n";
var iconMap = {
    "Lightning bolt": /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LightningBoltIcon */.YG, {}),
    Eye: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* EyeIcon */.tE, {}),
    "Hexagon with exclamation mark": /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* AlertIcon */.zM, {}),
    "Person with magnifying glass": /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ZoomFaceIcon */.R5, {}),
    "Ship to lightroom": /*#__PURE__*/ (0,jsx_runtime.jsx)(LightroomImportIcon/* default */.Z, {})
};
var ProductFeatures = function(param) {
    var title = param.title, productFeatures = param.productFeatures;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.HorizontalRule, {
                    bottomMargin: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-h2 font-semibold leading-compact mb-10 lg:mb-16 text-center",
                    children: title
                }),
                productFeatures === null || productFeatures === void 0 ? void 0 : productFeatures.map(function(param, index) {
                    var title = param.title, description = param.description, icon = param.icon, videoOrImage = param.videoOrImage, afterMarginClasses = param.afterMarginClasses;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageWithText */.E5, {
                        title: title,
                        datoVideoOrImage: videoOrImage,
                        orientation: index % 2 === 0 ? "image-left" : "image-right",
                        className: afterMarginClasses || (index === productFeatures.length - 1 ? "" : "mb-10 md:mb-18"),
                        icon: iconMap[icon],
                        children: description
                    }, title);
                })
            ]
        })
    });
};


// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 178 modules
var motion = __webpack_require__(12568);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(8151);
// EXTERNAL MODULE: ./src/config/env.ts
var env = __webpack_require__(5324);
;// CONCATENATED MODULE: ./src/components/hero/Hero.tsx











var heroFields = "\n  _modelApiKey\n  background {\n    responsiveImage(imgixParams: { auto: format, w: 1600 }) {\n      ...responsiveImageFragment\n    }\n  }\n  headingLine1\n  headingLine2\n  headingMaxWidth\n  description\n  ctaButtonText\n  ctaHref\n  ctaAppearance\n  ctaColor\n  previewLinksText\n  previewMedia {\n    responsiveImage(imgixParams: { auto: format, w: 1200 }) {\n      ...responsiveImageFragment\n    }\n    video {\n      mp4Url(res: medium)\n      thumbnailUrl\n    }\n  }\n  videoThumbnails {\n    responsiveImage(imgixParams: { auto: format, w: 1200 }) {\n      ...responsiveImageFragment\n    }\n  }\n";
function Hero(param) {
    var background = param.background, prelude = param.prelude, headingLine1 = param.headingLine1, headingLine2 = param.headingLine2, headingMaxWidth = param.headingMaxWidth, description = param.description, ctaButtonText = param.ctaButtonText, ctaHref = param.ctaHref, ctaAppearance = param.ctaAppearance, ctaColor = param.ctaColor, previewLinksText = param.previewLinksText, previewMedia = param.previewMedia, videoThumbnails = param.videoThumbnails;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(0), selectedIndex = ref3[0], setSelectedIndexRaw = ref3[1];
    var ref4 = (0,react.useState)(false), showVideo = ref4[0], setShowVideo = ref4[1];
    var setSelectedIndex = function(index) {
        setShowVideo(false);
        setSelectedIndexRaw(index);
    };
    var previewImage = previewMedia === null || previewMedia === void 0 ? void 0 : (ref = previewMedia[selectedIndex]) === null || ref === void 0 ? void 0 : ref.responsiveImage;
    var previewVideo = previewMedia === null || previewMedia === void 0 ? void 0 : (ref1 = previewMedia[selectedIndex]) === null || ref1 === void 0 ? void 0 : ref1.video;
    var previewThumbnail = videoThumbnails === null || videoThumbnails === void 0 ? void 0 : (ref2 = videoThumbnails[selectedIndex]) === null || ref2 === void 0 ? void 0 : ref2.responsiveImage;
    var paddingBottom = (previewThumbnail === null || previewThumbnail === void 0 ? void 0 : previewThumbnail.aspectRatio) ? 1 / previewThumbnail.aspectRatio * 100 : 60;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "w-full pt-16 md:pt-38 relative bg-mankey",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 right-0 left-0 h-[84%] md:h-[78%] bg-black",
                children: (background === null || background === void 0 ? void 0 : background.responsiveImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, background.responsiveImage), {
                        sizes: "(max-width: 768px) 100vw, 50vw"
                    }),
                    objectFit: "cover",
                    layout: "fill",
                    className: "absolute top-0 right-0 bottom-0 left-0",
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "m-auto max-w-[1050px] w-full text-center relative text-white px-3",
                children: [
                    prelude,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:gap-7.5 gap-4 flex flex-col px-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "md:text-90 font-[600] md:leading-[5.8rem] text-5xl leading-[3.25rem] mx-auto",
                                style: {
                                    maxWidth: headingMaxWidth
                                },
                                children: [
                                    headingLine1,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-[300]",
                                        children: headingLine2
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg max-w-160 mx-auto",
                                dangerouslySetInnerHTML: {
                                    __html: description
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative max-w-[385px] w-full mx-auto lg:mb-20 mb-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.AnchorButton, {
                                    appearance: ctaAppearance,
                                    colour: ctaColor,
                                    href: ctaHref === null || ctaHref === void 0 ? void 0 : ctaHref.replace("<account-site>", env/* ACCOUNT_BASE_URL */.dV),
                                    children: ctaButtonText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            paddingBottom: "".concat(paddingBottom, "%")
                        },
                        className: "w-full h-0 relative bg-off-white mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            exitBeforeEnter: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                className: "absolute top-0 right-0 bottom-0 left-0",
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                children: [
                                    previewImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        data: previewImage,
                                        style: {
                                            position: "absolute",
                                            top: 0,
                                            right: 0,
                                            bottom: 0,
                                            left: 0,
                                            maxWidth: "10000px"
                                        },
                                        objectFit: "cover",
                                        objectPosition: constants/* IMAGE_OBJECT_POSITION */.G,
                                        usePlaceholder: false
                                    }),
                                    previewVideo && previewThumbnail && !showVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: function() {
                                            return setShowVideo(true);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            data: previewThumbnail,
                                            style: {
                                                position: "absolute",
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0,
                                                maxWidth: "10000px"
                                            },
                                            objectFit: "cover",
                                            objectPosition: constants/* IMAGE_OBJECT_POSITION */.G,
                                            usePlaceholder: false
                                        })
                                    }),
                                    previewVideo && showVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FixedAspectRatioContainer */.vh, {
                                        aspectRatio: (previewThumbnail === null || previewThumbnail === void 0 ? void 0 : previewThumbnail.aspectRatio) || 1192 / 725,
                                        className: classnames_default()("flex-grow w-full overflow-hidden lg:w-auto", {
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                            src: previewVideo.mp4Url,
                                            autoPlay: true,
                                            playsInline: true,
                                            loop: false,
                                            controls: true
                                        })
                                    })
                                ]
                            }, selectedIndex)
                        })
                    }),
                    (previewLinksText === null || previewLinksText === void 0 ? void 0 : previewLinksText.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex mt-5 justify-center flex-wrap",
                        children: previewLinksText.split(",").slice(0, previewMedia === null || previewMedia === void 0 ? void 0 : previewMedia.length).map(function(linkText, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: classnames_default()("text-stealth-bomber px-2 md:px-5 py-1 transition-colors", {
                                    underline: selectedIndex === i,
                                    "text-shady-lady": selectedIndex !== i
                                }),
                                onClick: function() {
                                    return setSelectedIndex(i);
                                },
                                children: linkText.trim()
                            }, linkText);
                        })
                    })
                ]
            })
        ]
    });
}


// EXTERNAL MODULE: ./src/pages/select/index.tsx + 3 modules
var pages_select = __webpack_require__(62977);
;// CONCATENATED MODULE: ./src/pages/[partnership]/index.tsx













var PartnershipPage = function(param) {
    var preview = param.preview, plans = param.plans, subscription = param.subscription;
    var ref, ref1;
    var ref2 = (0,useQuerySubscription/* useQuerySubscription */.L)(subscription), tmp = ref2.data, ref3 = tmp === void 0 ? {} : tmp, data = ref3.page, banner = ref3.banner, error = ref2.error;
    if (error) {
        console.error(error);
    }
    if (!data) return null;
    var logo = data.logo, headerCtaHref = data.headerCtaHref, seo = data.seo, hero = data.hero, productFeaturesSection = data.productFeaturesSection, promoBanner = data.promoBanner, testimonials = data.testimonials, workflowSection = data.workflowSection, planComparison = data.planComparison, faqs = data.faqs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Layout */.Ar, {
        product: "select",
        preview: preview,
        siteBanner: banner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(site_banner/* SiteBanner */.b, (0,_object_spread/* default */.Z)({}, banner)) : null,
        headerCtaHref: headerCtaHref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SEO */.HJ, {
                title: "Narrative | Fast image editing | Photographers",
                children: (0,renderMetaTags/* renderMetaTags */.y)(seo)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hero), {
                prelude: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mb-10 max-w-[320px] w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        data: logo === null || logo === void 0 ? void 0 : logo.responsiveImage,
                        objectFit: "contain",
                        layout: "responsive"
                    })
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFeatures, (0,_object_spread/* default */.Z)({}, productFeaturesSection)),
            (promoBanner === null || promoBanner === void 0 ? void 0 : (ref = promoBanner.backgroundImage) === null || ref === void 0 ? void 0 : (ref1 = ref.responsiveImage) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PromoBanner, {
                title: promoBanner.title,
                description: promoBanner.description,
                form: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* StartFreeButtons */.zH, {
                    emailButtonAppearance: "rainbow",
                    product: promoBanner.product,
                    className: "max-w-130",
                    ctaHref: promoBanner.ctaHref
                }),
                backgroundColour: promoBanner.backgroundColor,
                backgroundImagePath: promoBanner.backgroundImage.responsiveImage.src,
                large: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-col items-center py-12 px-12 bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CredibilityBar */.KW, {
                        logos: pages_select.COMPANY_LOGOS,
                        label: "Featured in:"
                    })
                })
            }),
            testimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Carousel */.lr, (0,_object_spread/* default */.Z)({}, testimonials)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkflowSteps, (0,_object_spread/* default */.Z)({}, workflowSection)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanComparison/* PlanComparison */.m, (0,_object_spread/* default */.Z)({
                stripePlans: plans
            }, planComparison)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Accordion */.UQ, (0,_object_spread/* default */.Z)({}, faqs))
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _partnership_ = (PartnershipPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2977,9774,2888,179], function() { return __webpack_exec__(70773); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);